import { Component, DestroyRef, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TenantService } from '@app/Services/tenant.service';
import { CreateTenantDto } from '@app/Models/create-tenant.dto';
import { MessageJobSeverity } from '@app/Enums';
import { PermissionService } from '@app/Services';
import { Permissions } from '@app/Models/Permissions';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NewTenantFormComponent } from '../NewTenantForm/new-tenant-form.component';
import { JobLiveViewComponent } from '../../../Jobs/job.liveview.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'new-tenant',
    templateUrl: './new-tenant.component.html',
    styleUrls: ['./new-tenant.component.scss'],
    providers: [Title],
    imports: [MatButton, RouterLink, MatIcon, NewTenantFormComponent, JobLiveViewComponent]
})
export class NewTenantComponent {
    public jobId: string;
    public tenantId: string;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private readonly tenantService: TenantService,
        private readonly permissionService: PermissionService,
        private readonly router: Router,
        private readonly title: Title,
    ) {
        this.title.setTitle('ACT - New Tenant');
    }

    isNewTrialButtonAvailable(): boolean {
      return this.permissionService.hasPermission(Permissions.freeTrialAdministration);
    }

    public createTenant(tenant: CreateTenantDto): void {
        this.tenantService
            .create(tenant)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (job) => {
                    this.jobId = job.JobId;
                    this.tenantId = job.TenantId;
                }
            });
    }

    public jobComplete(event: MessageJobSeverity): void {
        if (event === MessageJobSeverity.Success) {
            this.tenantService.getTenants()
                .then(() => {
                    setTimeout(() => {
                        this.router.navigate(['/tenant', this.tenantId]);
                    }, 1000);
                });
        }
    }
}

